// src/components/MusicStore/CustomAlert.jsx
import React from "react";
import ReactDOM from "react-dom";
import LOGO from "./../images/logo/von3.png"; // adjust the path as needed


const globalButtonCSS = `
  button {
    transition: background-color 0.2s ease, transform 0.1s ease;
  }
  button:hover {
    background-color: rgba(200, 50, 255, 0.7);
  }
  button:active {
    transform: scale(0.95);
  }
`;
export default function CustomAlert({
  message,
  onClose,          // used for alert close OR confirm "Cancel"
  onConfirm,        // used for confirm "OK"
  mode = "alert",   // "alert" | "confirm"
  confirmLabel = "OK",
  cancelLabel = "Cancel",
}) {
    return ReactDOM.createPortal(
    <div
        data-role="alert-overlay"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2147483647,
        }}
        onClick={onClose}
      >
        <div
          style={{
            background:"rgba(0,0,40,1)",
            padding: "1rem 2rem",
            border:"5px double #21d7c5",
            borderRadius: "12px",

            boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
            textAlign: "center",
            fontFamily: "Oxanium",
            maxWidth: "90%",
          }}
          
          onClick={(e) => e.stopPropagation()}
        >
            <img
           src={LOGO}
          alt=""
          className="responsive-logo"
          style={{
            width: "80px",
            position: "relative",
            top: "0rem",
            alignItems: "center",
            left: "-5px",
            zIndex: 9999}}
        />
          <p style={{ marginBottom: "1rem", fontSize: "1rem", fontWeight: "bold" }}>
            {message}
          </p>
       {mode === "confirm" ? (
         <div style={{ display: "flex", gap: ".5rem", justifyContent: "center" }}>
           <button
             className="freshButton"
             onClick={onClose}
             style={{
               backgroundColor: "red",
               color: "gold",
               border: "1px solid rgba(0,0,0,.15)",
               borderRadius: 4,
               fontFamily: "Oxanium",
               padding: ".5rem 1rem",
               cursor: "pointer",
             }}
           >
             {cancelLabel}
           </button>
           <button
             className="freshButton"
             onClick={onConfirm || onClose}
             style={{
               backgroundColor: "#21d7c5",
               color: "white",
               border: "none",
               borderRadius: 4,
               fontFamily: "Oxanium",
               padding: ".5rem 1rem",
               cursor: "pointer",
             }}
           >
             {confirmLabel}
           </button>
         </div>
       ) : (
         <button
           className="freshButton"
           onClick={onClose}
           style={{
             backgroundColor: "#21d7c5",
             color: "white",
             border: "none",
             borderRadius: "4px",
             fontFamily: "Oxanium",
             padding: "0.5rem 1rem",
             cursor: "pointer",
           }}
         >
           {confirmLabel}
         </button>
       )}
        </div>
      </div>,
      document.getElementById("alert-root") || document.body
    );
  }